import React, { useEffect, useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CustomTextField from '../components/customTextField';
import NumberFormat from 'react-number-format';

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="Rp. "
        />
    );
}

export default function AddTagihanLab(props) {

    const [keterangan, setKeterangan] = useState("")
    const [qty, setQTY] = useState("")
    const [amount, setAmount] = useState("")
    const [totalAmount, setTotalAmount] = useState("")

    const [errorKeterangan, setErrorKeterangan] = React.useState(false);
    const [texterrorKeterangan, setTextErrorKeterangan] = React.useState(null);
    const [errorQTY, setErrorQTY] = React.useState(false);
    const [texterrorQTY, setTextErrorQTY] = React.useState(null);
    const [errorAmount, setErrorAmount] = React.useState(false);
    const [texterrorAmount, setTextErrorAmount] = React.useState(null);

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleSave = () => {
        if (keterangan === "") {
            setErrorKeterangan(true)
            setTextErrorKeterangan("Keterangan wajib diisi")
        } else if (qty === "") {
            setErrorQTY(true)
            setTextErrorQTY("QTY wajib diisi")
        } else if (amount === "") {
            setErrorAmount(true)
            setTextErrorAmount("Amount wajib diisi")
        } else {
            let payload = {
                keterangan: keterangan,
                qty: qty,
                amount: amount,
                totalAmount: totalAmount,
            }
            let tagihan = {
                pickType: { id: 4, name: 'Laboratorium' },
                keterangan: keterangan,
                qty: qty,
                amount: amount,
                totalAmount: totalAmount,
            }
            props.onSubmit(payload)
            props.onSubmitPayment(tagihan)
        }
    }

    useEffect(() => {
    }, [])


    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Detail Tagihan Laboratorium</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <TextField
                            required={true}
                            label={"Keterangan"}
                            style={{ width: '90%' }}
                            error={errorKeterangan}
                            helperText={texterrorKeterangan}
                            onChange={(e) => {
                                setKeterangan(e.target.value)
                                setErrorKeterangan(false)
                                setTextErrorKeterangan("")
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                    fontFamily: 'Poppins',
                                }
                            }}
                        />
                    </div>
                    <div className="column-2">
                        <TextField
                            required={true}
                            label={"QTY"}
                            style={{ width: '90%', textAlign: 'left' }}
                            error={errorQTY}
                            helperText={texterrorQTY}
                            onChange={(e) => {
                                setQTY(e.target.value)
                                setErrorQTY(false)
                                setTextErrorQTY("")
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                    fontFamily: 'Poppins',
                                }
                            }}
                        />
                    </div>

                    <div className="column-1">
                        <TextField
                            required={true}
                            label={"Amount"}
                            style={{ width: '90%' }}
                            error={errorAmount}
                            helperText={texterrorAmount}
                            onChange={(e) => {
                                setAmount(e.target.value)
                                setTotalAmount(Number(e.target.value) * Number(qty))
                                setErrorAmount(false)
                                setTextErrorAmount(null)
                                forceUpdate()
                            }}
                            // onBlur={(e) => {
                            //     setTotalAmount(Number(e.target.value) * Number(qty))
                            //     console.log(Number(e.target.value) * Number(qty));
                            //     forceUpdate()
                            // } }
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                    fontFamily: 'Poppins',
                                }
                            }}
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                        />
                    </div>
                    <div className="column-2" style={{ textAlign: 'left' }}>
                        <TextField
                            disabled
                            label={"Total Amount"}
                            style={{ width: '90%' }}
                            value={totalAmount}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                    fontFamily: 'Poppins',
                                }
                            }}
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                        />
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => handleSave()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}